import { render } from "./TestLayout.vue?vue&type=template&id=31d80d5e"
import script from "./TestLayout.vue?vue&type=script&lang=js"
export * from "./TestLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__